.app-hero-slide {
    height: 100%;
    position: relative;

    .hero-inner {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        max-width: 1500px;
        margin: 0 auto;
        padding: 20px 10%;
    }

    .hero-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: 0%;
        z-index: -25;
    }

    .hero-content {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: flex-end;
        max-width: 460px;

        img {display: none;}
        .hero-slider-pause { display: none; }
    }

    .hero-slide__description, .hero-slide__description p {
        @include text-size(21);
        @include line-height(28);
        margin: 0; padding: 0;
    }

    .hero-slide__description {
        margin-bottom: 25px;

        p {
            color: $primary;
            font-family: $font-family-secondary;
            // font-weight: 300;
            // font-size: 16px;
            // line-height: 1.5;
            color: #555c63;
        }
    }

    h1 {
        font-weight: 700;
        line-height: 1.15;
        margin: 0 0 20px 0;
        padding: 0;
        color: $primary;
    }

    @media only screen and (min-width: 999.98px) and (max-width: 1400px) {
        .hero-img {
            width: 50%;
        }

        .hero-inner {
            padding-left: 10%;
            padding-right: 10%;
        }
    }

    @media only screen and (max-width: 1000px) {

        .hero-inner {
            flex-direction: column;
            padding: 0;
            justify-content: flex-start;
            height: auto;
            max-width: 100%;
            align-items: center;
        }
        .hero-img {
            position: relative;
            width: 100%;
            max-height: 400px;
            height: 100%;
            border-bottom: 4px solid $primary;
            background-color: $gray-lite;
            object-position: center;
        }
        .hero-content {
            display: block;
            padding: 15px 5%;
            text-align: center;
            max-width: 100%;

            h1 {
                line-height: 1.15;
            }
            img {display: none;}
        }
        .hero-slide__description, .hero-slide__description p {
            @include text-size(16);
            @include line-height(24);
        }
        .hero-ctas {
            display:flex;
            flex-direction: column;
            align-items: center;

            .btn {
                @include line-height(27);
            }
        }
    }
}